import React from "react";
import { Text } from "../../ui/Text/Text";
import { cn } from "../../../lib/cn";

export function PageContainer({
  className,
  title,
  description,
  breadcrumb,
  actions,
  children,
  maxWidth = "7xl",
  noPadding = false,
}) {
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "3xl": "max-w-3xl",
    "4xl": "max-w-4xl",
    "5xl": "max-w-5xl",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
    full: "max-w-full",
  };

  return (
    <div
      className={cn(
        "w-full mx-auto",
        maxWidthClasses[maxWidth],
        !noPadding && "px-4 sm:px-6 lg:px-8 py-6",
        className,
      )}
    >
      {/* Breadcrumb */}
      {breadcrumb && <div className="mb-4">{breadcrumb}</div>}

      {/* Header */}
      {(title || description || actions) && (
        <div className="mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="flex-1">
              {title && (
                <Text className="block text-2xl font-bold text-gray-900 mb-1">
                  {title}
                </Text>
              )}
              {description && (
                <Text className="block text-sm text-gray-600">
                  {description}
                </Text>
              )}
            </div>

            {actions && (
              <div className="flex items-center gap-2">{actions}</div>
            )}
          </div>
        </div>
      )}

      {/* Content */}
      <div className="space-y-3">{children}</div>
    </div>
  );
}
